
import { GoogleGenAI, Type } from "@google/genai";
import { Staff, Shift, DepartmentType } from "../types";

export const buildRotaWithAI = async (
  staff: Staff[],
  shifts: Shift[],
  department: DepartmentType,
  constraints: string
) => {
  try {
    // Fix: Create a new GoogleGenAI instance right before making an API call to ensure use of the most up-to-date API key context.
    const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
    const prompt = `
      You are an expert workforce planner for the YMCA. 
      Generate a staffing plan for the following department: ${department}.
      
      Staff Data: ${JSON.stringify(staff)}
      Shift Requirements: ${JSON.stringify(shifts)}
      
      Constraints: ${constraints}
      
      Output a JSON object with:
      1. assignments: an array of objects { shiftId, staffId }
      2. reasoning: a short explanation of why these assignments are fair and compliant.
      3. risks: any potential understaffing or overstaffing issues detected.
    `;

    const response = await ai.models.generateContent({
      // Fix: Upgraded to gemini-3-pro-preview for advanced reasoning required by workforce optimisation tasks.
      model: 'gemini-3-pro-preview',
      contents: prompt,
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            assignments: {
              type: Type.ARRAY,
              items: {
                type: Type.OBJECT,
                properties: {
                  shiftId: { type: Type.STRING },
                  staffId: { type: Type.STRING }
                }
              }
            },
            reasoning: { type: Type.STRING },
            risks: { type: Type.ARRAY, items: { type: Type.STRING } }
          }
        }
      }
    });

    return JSON.parse(response.text || '{}');
  } catch (error) {
    console.error("AI Rota Build Error:", error);
    throw error;
  }
};

export const getShiftExplanation = async (shift: Shift, staff: Staff) => {
  try {
    // Fix: Create a new GoogleGenAI instance right before making an API call.
    const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
    const prompt = `
      Explain why ${staff.firstName} ${staff.lastName} is assigned to the ${shift.roleName} shift at ${shift.startTime}.
      Consider skills: ${JSON.stringify(staff.skills)}, contract: ${staff.contractType}, and weekly hours: ${staff.maxWeeklyHours}.
      Ensure the tone is professional, helpful, and aligns with YMCA community values.
    `;

    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: prompt
    });

    // Fix: Directly accessing .text property as per standard guidelines.
    return response.text || "Explanation currently unavailable.";
  } catch (error) {
    console.error("AI Explanation Error:", error);
    return "Explanation currently unavailable.";
  }
};
